export enum MODAL_TYPE {
  LABEL_ADDITION = 'labelAdd',
  LABEL_CREATION = 'labelCreation'
}

export const LABELS_COUNT_PER_REQUEST = 20;
